import { axios } from "../../lib/axios";

export const DeleteStudent = (studentId: string) => {
    return axios.delete(`/student/${studentId}`)
        .then(response => response.data);
};